import { Link, useNavigate } from 'react-router-dom';
import Button from '../../../../components/Button/Button';
import './RegisterPage.css';
import { TextField } from '../../../../components/TextField/TextField';
import RegisterForm from './components/register-form';
import { useState } from 'react';
import { ButtonProps } from '../../../../types';
import Header from '../../partials/Header/Header';
import Footer from '../../partials/Footer/Footer';
import { useAuth } from '../../../../contexts/AuthContext';
import api from '../../../../services/api';

function RegisterPage() {
    const navigate = useNavigate();
    const { login } = useAuth();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConfirmation, setPasswordConfirmation] = useState('');

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const [firstNameError, setFirstNameError] = useState('');
    const [lastNameError, setLastNameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');

    const fieldsValidated = (): boolean => {
        let error = false;

        if (firstName === '') {
            setFirstNameError('First name is required');
            error = true;
        }

        if (lastName === '') {
            setLastNameError('Last name is required');
            error = true;
        }
        
        if (password !== passwordConfirmation) {
            setPasswordError('Passwords do not match');
            error = true;
        }

        if (password.length < 8) {
            setPasswordError('Password must be at least 8 characters long');
            error = true;
        }

        if (email.indexOf('@') === -1) {
            setEmailError('Email must be valid');
            error = true;
        }

        return error;
    }

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        setLoading(true);

        setError('');
        setFirstNameError('');
        setLastNameError('');
        setEmailError('');
        setPasswordError('');        

        try {
            if (fieldsValidated()) {
                return;
            }

            await api.post('/register', {
                first_name: firstName,
                last_name: lastName,
                email,
                password,
                password_confirmation: passwordConfirmation
            });
            
            await login(email, password);    
            
            navigate('/dashboard');
        } catch (err: any) {
            console.log(error);
        } finally {
            setLoading(false);
            return;
        }
    };

    const submitButtonProps: ButtonProps = {
        id: "register",
        name: "Register",
        type: "submit",
        props: {
            onClick: handleSubmit
        }
    }

    return (
        <div id="register-page">
            <Header />

            <main>
                <div className="container form">
                    <div className="form-title">
                        <h2>Register Now!</h2>
                        <p>Create an account to start your learning journey.</p>
                    </div>

                    <RegisterForm action="#" method="POST">
                        <TextField 
                            id="firstname"
                            name="firstname"
                            label="First name"
                            type="text"
                            autoComplete="firstname"
                            placeholder="Enter your first name"
                            onChange={(e: any) => setFirstName(e.target.value)}
                            value={firstName}
                            required
                            error={firstNameError}
                        />

                        <TextField 
                            id="lastname"
                            name="lastname"
                            label="Last name"
                            type="text"
                            autoComplete="lastname"
                            placeholder="Enter your last name"
                            onChange={(e: any) => setLastName(e.target.value)}
                            value={lastName}
                            required
                            error={lastNameError}
                        />

                        <hr className="divider" />

                        <TextField
                            id="email"
                            name="email"
                            label="Email address"
                            type="email"
                            autoComplete="email"
                            placeholder="Enter your email"
                            onChange={(e: any) => setEmail(e.target.value)}
                            value={email}
                            required
                            error={emailError}
                        />

                        <TextField
                            id="password"
                            name="password"
                            label="Password"
                            type="password"
                            autoComplete="current-password"
                            placeholder="Enter your password"
                            onChange={(e: any) => setPassword(e.target.value)}
                            value={password}
                            required
                            error={passwordError}
                        />

                        <TextField
                            id="confirm-password"
                            name="confirm-password"
                            label="Confirm Password"
                            type="password"
                            autoComplete="confirm-password"
                            placeholder="Confirm your password"
                            onChange={(e: any) => setPasswordConfirmation(e.target.value)}
                            value={passwordConfirmation}
                            required
                            error={passwordError}
                        />

                        <hr className="divider" />

                        <Button 
                            {...submitButtonProps} 
                            loading={loading}
                        />
                    </RegisterForm>
                    
                    <p className="login">
                        <span>Do have an account?</span>
                        <Link to="/login" className="link">
                            Login
                        </Link>
                    </p>
                </div>
            </main>

            <Footer />
        </div>
    );
}

export default RegisterPage;